import React from 'react';

import _ from 'lodash';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputRadioGroupField from '../../Fields/InputRadioGroupField';
import FeeTable from '../../Fields/FeeTable';


class BillingProfileInvoicesPanel extends React.Component {
  _onFeeChange(type) {
    return (ident, value) => {
      const fees = _.cloneDeep(this.props.billingProfile.fields.fees);
      if (ident === null) ident = fees[type].value.length;
      fees[type].value[ident] = value;

      this._onInputChange('fees')(fees);
    };
  }


  _onInputChange(inputId) {
    return value => {
      switch (inputId) {
        case 'mail_invoice_option':
          value = (value === 'true') ? true : false;
          break;
        default:
      }

      this.props.onBillingProfileInputChange(inputId, value);
    };
  }


  render() {
    const {
      billingProfile,
      fieldConfiguration,
      newMode,
      editMode
    } = this.props;

    const mailInvoiceFeeTableRows = billingProfile.fields.fees.mail_invoice.value.map((fee, index) => {
      return { ident: index, data: fee };
    });

    return (
      <div>
        <FieldGroup>
          <Field label="Mail Invoice Option"
            id="parkchirp--billing-profile--mail-invoice-option"
            layout="columns">
            <InputRadioGroupField inputId="parkchirp--billing-profile--mail-invoice-option"
              options={fieldConfiguration.mail_invoice_option.options}
              value={billingProfile.fields.mail_invoice_option.value}
              editMode={(newMode || editMode)}
              onChange={this._onInputChange('mail_invoice_option')}
            />
          </Field>
          <Field>
            <FeeTable inputId="parkchirp--billing-profile--mail-invoice-fee"
              feeRows={mailInvoiceFeeTableRows}
              feeType="MAIL_INVOICE"
              allowAdd={(newMode || editMode)}
              editMode={(newMode || editMode)}
              onFeeChange={this._onFeeChange('mail_invoice')}
            />
          </Field>
        </FieldGroup>
      </div>
    );
  }
}
export default BillingProfileInvoicesPanel;
